import { Stack, StackProps } from '@mui/system';
import { Card, Text, VSpacer } from '@/components/DesignSystem';
import { ReactNode } from 'react';

interface DemoProps extends Omit<StackProps, 'label'> {
  children?: ReactNode,
  label?: string,
}

export const DemoBlock = ({ label, children, ...props }: DemoProps) => (
  <Card testID="demo-block-card">
    <Text category="body-large">{label}</Text>
    <Stack {...props}>
      <VSpacer size="5" />
      {children}
      <VSpacer size="5" />
    </Stack>
  </Card>
);
